import '../styles/HowItWorks.css'

const HowItWorks = () => {
    return (
        <div className='hiwContainer'>
            <h1>How EcoRent Works</h1>
            <section className='listContainer'>
                <ol>
                <li>1. Find an item you'd like to rent through our categories or search</li>
                <li>2. Request the item from the renter.</li>
                <li>3. Once accepted, reach out to the renter and arrange pickup.</li>
                </ol>
        
            </section>
        </div>
    )
}

export default HowItWorks


